<script>
import SISUsuarioClienteService from '@/services/SistemaDKP/SISUsuarioCliente.service';
import { mapGetters } from 'vuex';
import { BOverlay } from 'bootstrap-vue';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

const usuarioClienteService = new SISUsuarioClienteService();
export default {
  name: 'UsuarioRepresentante',
  components: { BOverlay },
  props: ['value'],
  data() {
    return {
      isLoading: false,
      codigoClienteNaoSelecionado: null,
      clienteRazaoSocialNaoSelecionado: null,
      codigoClienteSelecionado: null,
      clienteRazaoSocialSelecionado: null,
      isSelectedAllNaoSelecionado: false,
      isSelectedAllSelecionado: false,
      selectedClienteSelecionado: [],
      selectedClienteNaoSelecionado: [],
      columnsSelecionados: [
        {
          label: '#',
          key: 'selected',
        },
        {
          label: 'Código',
          key: 'clienteiderp',
        },
        {
          label: 'Cliente',
          key: 'clienterazaosocial',
        },
        {
          label: 'Açõe',
          key: 'acoes',
        },
      ],
      columnsNaoSelecioando: [
        {
          label: '#',
          key: 'selected',
        },
        {
          label: 'Código',
          key: 'clienteiderp',
        },
        {
          label: 'Cliente',
          key: 'clienterazaosocial',
        },
        {
          label: 'Açõe',
          key: 'acoes',
        },
      ],
    };
  },
  watch: {
    value: {
      async handler(newValue) {
        if (typeof newValue.usuarioid !== 'undefined' && newValue.usuarioid !== null) {
          await this.listarRepresentanteSlecioandoENapSelecionado(newValue);
        }
      },
      immediate: true, // Chama buscarPerfils imediatamente após a montagem do componente
    },
  },
  computed: {
    ...mapGetters('SISUsuarioCliente', {
      filtersNapSelecionado: 'getFiltersNaoSelecionado',
      filtersSelecionados: 'getFiltersSelecionado',
      clientesNaoSelecionados: 'getClientesNaoSelecionados',
      clientesSelecionados: 'getClientesSelecionados',
    }),
    dataMetaNaoSelecionado() {
      const localCount = this.clientesNaoSelecionados.length;
      const meta = {
        page: this.filtersNapSelecionado.perPage * (this.filtersNapSelecionado.page - 1) + (localCount ? 1 : 0),
        perPage: this.filtersNapSelecionado.perPage * (this.filtersNapSelecionado.page - 1) + localCount,
        total: this.filtersNapSelecionado.total,
      };
      if (meta.page && meta.perPage && meta.total) {
        return `Mostrando ${meta.page} de ${meta.perPage} entradas de ${meta.total} entradas`;
      }
      return 'Mostrando 0 até 0 entradas de 0 entradas';
    },
    dataMetaSelecionado() {
      const localCount = this.clientesSelecionados.length;
      const meta = {
        page: this.filtersSelecionados.perPage * (this.filtersSelecionados.page - 1) + (localCount ? 1 : 0),
        perPage: this.filtersSelecionados.perPage * (this.filtersSelecionados.page - 1) + localCount,
        total: this.filtersSelecionados.total,
      };
      if (meta.page && meta.perPage && meta.total) {
        return `Mostrando ${meta.page} de ${meta.perPage} entradas de ${meta.total} entradas`;
      }
      return 'Mostrando 0 até 0 entradas de 0 entradas';
    },
    dataUsuario: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    resertVariaveisGerais() {
      this.isSelectedAllNaoSelecionado = false;
      this.selectedClienteSelecionado = [];
      // this.$refs.refTableSelecionados.clearSelected()
      this.isSelectedAllSelecionado = false;
      this.selectedClienteNaoSelecionado = [];
      // this.$refs.refTableNaoSelecionado.clearSelected()
    },
    // INICIO -> USUARIO x REPRESENTANTE
    async buscarRepresentanteNaoSelecionado() {
      try {
        this.isLoading = true;
        this.$store.commit('SISUsuarioCliente/setCodigoNaoSelecionado', this.codigoClienteNaoSelecionado);
        this.$store.commit('SISUsuarioCliente/setClienteRazaoSocialNaoSelecionado', this.clienteRazaoSocialNaoSelecionado);
        this.$store.commit('SISUsuarioCliente/setPageNaoSelecionado', 1);
        await usuarioClienteService.listarClienteNaoSelecionados({
          ...this.filtersNapSelecionado,
          usuarioId: this.dataUsuario.usuarioid,
          page: 1,
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async limparBuscarRepresentanteNaoSelecionado() {
      this.codigoClienteNaoSelecionado = null;
      this.clienteRazaoSocialNaoSelecionado = null;
      this.$store.commit('SISUsuarioCliente/setCodigoNaoSelecionado', null);
      this.$store.commit('SISUsuarioCliente/setClienteRazaoSocialNaoSelecionado', null);
      this.$store.commit('SISUsuarioCliente/setPageNaoSelecionado', 1); // Resetar para página 1
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async buscarRepresentanteSelecionado() {
      try {
        this.isLoading = true;
        this.$store.commit('SISUsuarioCliente/setCodigoSelecionado', this.codigoClienteSelecionado);
        this.$store.commit('SISUsuarioCliente/setClienteRazaoSocialSelecionado', this.clienteRazaoSocialSelecionado);
        this.$store.commit('SISUsuarioCliente/setPageSelecionado', 1);
        await usuarioClienteService.listarClienteSelecionados({
          ...this.filtersSelecionados,
          usuarioId: this.dataUsuario.usuarioid,
          page: 1,
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    limparBuscarRepresentanteSelecionado() {
      this.codigoClienteSelecionado = null;
      this.clienteRazaoSocialSelecionado = null;
      this.$store.commit('SISUsuarioCliente/setCodigoSelecionado', null);
      this.$store.commit('SISUsuarioCliente/setClienteRazaoSocialSelecionado', null);
      this.$store.commit('SISUsuarioCliente/setPageSelecionado', 1);
      this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async adicionarTodosCliente() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Adicionando todos...',
          icon: 'LoaderIcon',
          variant: 'success',
        },
      });
      await usuarioClienteService.adicionarTodosCliente(this.dataUsuario.usuarioid);
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async adicionarCliente(repsentante) {
      await usuarioClienteService.create({
        id_usuario: this.dataUsuario.usuarioid,
        clienteid: repsentante.clienteid,
      });
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async removerRepresentante(repsentante) {
      await usuarioClienteService.destroy(this.dataUsuario.usuarioid, repsentante.clienteid);
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async removerTodosClienteSelecionados() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Removendo todos...',
          icon: 'LoaderIcon',
          variant: 'success',
        },
      });
      await usuarioClienteService.removerTodosClienteSelecionados(this.dataUsuario.usuarioid);
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async removerSelecionadoClienteSelecionado() {
      await usuarioClienteService.removerSelecionadoClienteSelecionado({
        usuarioId: this.dataUsuario.usuarioid,
        clienteIds: this.selectedClienteSelecionado.map((item) => item.clienteid),
      });
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async adicionarSelecionadoClienteNaoSelecionado() {
      await usuarioClienteService.adicionarSelecionadoClienteNaoSelecionado({
        usuarioId: this.dataUsuario.usuarioid,
        clienteIds: this.selectedClienteNaoSelecionado.map((item) => item.clienteid),
      });
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async listarRepresentanteSlecioandoENapSelecionado(newValue) {
      this.$store.commit('SISUsuarioCliente/setLoading', true);
      await usuarioClienteService.listarClienteNaoSelecionados({
        ...this.filtersNapSelecionado,
        usuarioId: newValue.usuarioid,
      });
      await usuarioClienteService.listarClienteSelecionados({
        ...this.filtersSelecionados,
        usuarioId: newValue.usuarioid,
      });
      this.resertVariaveisGerais();
      this.$store.commit('SISUsuarioCliente/setLoading', false);
    },
    async onChanePaginationRepresetanteNaoSelecionado(event) {
      try {
        this.$store.commit('SISUsuarioCliente/setLoading', true);
        await usuarioClienteService.listarClienteNaoSelecionados({
          ...this.filtersNapSelecionado,
          usuarioId: this.dataUsuario.usuarioid,
          page: event,
          perPage: 8,
          clienteiderp: this.codigoClienteNaoSelecionado,
          clienterazaosocial: this.clienteRazaoSocialNaoSelecionado,
        });
        this.$store.commit('SISUsuarioCliente/setPageNaoSelecionado', event);
      } catch (error) {
        console.error(error);
      } finally {
        this.$store.commit('SISUsuarioCliente/setLoading', false);
      }
    },
    async onChanePaginationRepresetanteSelecionados(event) {
      try {
        this.$store.commit('SISUsuarioCliente/setLoading', true);
        await usuarioClienteService.listarClienteSelecionados({
          ...this.filtersSelecionados,
          usuarioId: this.dataUsuario.usuarioid,
          page: event,
          perPage: 8,
          clienteiderp: this.codigoClienteSelecionado,
          clienterazaosocial: this.clienteRazaoSocialSelecionado,
        });
        this.$store.commit('SISUsuarioCliente/setPageSelecionado', event);
      } catch (error) {
        console.error(error);
      } finally {
        this.$store.commit('SISUsuarioCliente/setLoading', false);
      }
    },
    async onRowSelectedRepSelecionado(item) {
      this.selectedClienteSelecionado = item;
    },
    selectAllRepresentanteSelecionado(selected) {
      if (selected.allSelected) {
        this.isSelectedAllNaoSelecionado = true;
        this.$refs.refTableSelecionados.selectAllRows();
      } else {
        this.isSelectedAllNaoSelecionado = false;
        this.$refs.refTableSelecionados.clearSelected();
      }
    },
    async onRowSelectedRepNaoSelecionado(item) {
      this.selectedClienteNaoSelecionado = item;
    },
    selectAllRepresentanteNaoSelecionado(selected) {
      if (selected.allSelected) {
        this.isSelectedAllSelecionado = true;
        this.$refs.refTableNaoSelecionado.selectAllRows();
      } else {
        this.isSelectedAllSelecionado = false;
        this.$refs.refTableNaoSelecionado.clearSelected();
      }
    },
    // FIM -> USUARIO x REPRESENTANTE
  },
};
</script>

<template>
  <b-overlay
      variant="white"
      :show="isLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
  >
  <b-row>
    <b-col cols="12" md="6">
      <div class="mb-3">
        <h5 class="mb-3 text-primary font-weight-bold">
          <feather-icon icon="UsersIcon" size="20" class="mr-1"/>
          Clientes Disponíveis
        </h5>
      </div>
      <b-row class="align-items-center">
        <b-col cols="12" md="4" class="mb-2 mb-md-0">
          <b-form-group
              label="Código"
              label-for="basicInput"
          >
            <b-form-input
                id="basicInput"
                placeholder="Código"
                v-model="codigoClienteNaoSelecionado"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mb-2 mb-md-0">
          <b-form-group
              label="Nome"
              label-for="basicInput"
          >
            <b-form-input
                id="basicInput"
                placeholder="Nome"
                v-model="clienteRazaoSocialNaoSelecionado"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6" md="auto" class="mb-2 mb-md-0">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="btn-icon w-100 d-md-inline-block"
              @click="buscarRepresentanteNaoSelecionado"
          >
            <feather-icon icon="SearchIcon" class="d-md-none"/>
            <span class="d-none d-md-inline"><feather-icon icon="SearchIcon"/></span>
            <span class="d-md-none ml-1">Buscar</span>
          </b-button>
        </b-col>
        <b-col cols="6" md="auto" class="mb-2 mb-md-0">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="btn-icon w-100 d-md-inline-block"
              @click="limparBuscarRepresentanteNaoSelecionado"
          >
            <feather-icon icon="TrashIcon" class="d-md-none"/>
            <span class="d-none d-md-inline"><feather-icon icon="TrashIcon"/></span>
            <span class="d-md-none ml-1">Limpar</span>
          </b-button>
        </b-col>
        <b-col
            cols="12"
            class="mb-3"
        >
          <div class="d-flex flex-column flex-md-row" style="gap: 10px; align-items: stretch;">
            <!-- <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="btn-icon flex-fill flex-md-grow-0"
                @click="adicionarTodosCliente"
                disabled
              >
                :disabled="clientesNaoSelecionados.length === 0"
              Adicionar Todos
            </b-button> -->
            <b-button
                v-if="selectedClienteNaoSelecionado.length > 0"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-success"
                class="btn-icon flex-fill flex-md-grow-0"
                @click="adicionarSelecionadoClienteNaoSelecionado"
            >
              Adicionar Selecionados
            </b-button>
            <span
                v-if="selectedClienteNaoSelecionado.length > 0"
                class="font-weight-bolder text-center text-md-left mt-2 mt-md-0"
            >{{selectedClienteNaoSelecionado.length}} selecionados</span>
          </div>
        </b-col>
        <b-col cols="12" class="mb-3">
          <b-table
              responsive="sm"
              ref="refTableNaoSelecionado"
              :fields="columnsNaoSelecioando"
              :items="$store.getters['SISUsuarioCliente/getClientesNaoSelecionados']"
              selectable
              select-mode="multi"
              show-empty
              empty-text="Nenhum registro encontrado"
              @row-selected="onRowSelectedRepNaoSelecionado"
              :busy="$store.getters['SISUsuarioCliente/getLoading']"
              class="mobile-table"
          >
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle" variant="primary"></b-spinner>
                    <strong class="ml-2">Carregando...</strong>
                </div>
            </template>
            <template v-slot:head(selected)="data">
              <b-form-checkbox
                  id="cliente-selecionarTodos-nao-selecionados"
                  v-model="data.allSelected"
                  @change="selectAllRepresentanteNaoSelecionado(data)"
              >
              </b-form-checkbox>
              <b-tooltip
                  target="cliente-selecionarTodos-nao-selecionados"
                  title="Marcar todos"
                  variant="secondary"
              >
              </b-tooltip>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <b-form-checkbox
                    v-model="rowSelected"
                    disabled
                >
                </b-form-checkbox>
              </template>
              <template v-else>
                <b-form-checkbox
                    v-model="rowSelected"
                    disabled
                >
                </b-form-checkbox>
              </template>
            </template>
            <template v-slot:cell(acoes)="props">
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="gradient-success"
                  class="btn-icon"
                  @click="adicionarCliente(props.item)"
              >
                <feather-icon icon="PlusIcon"/>
              </b-button>
            </template>
          </b-table>
        </b-col>
        <b-col
            cols="12"
            v-if="!$store.getters['SISUsuarioCliente/getLoading']"
        >
          <!-- <div v-if="clientesNaoSelecionados.length === 0" class="text-center">
                    <span class="font-weight-bold">
                      Todos os clientes foram selecionados
                    </span>
          </div> -->
          <div class="d-flex justify-content-between flex-wrap mb-1">
            <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap ">
                      {{ dataMetaNaoSelecionado }}
                    </span>
            </div>
            <div>
              <b-pagination
                  v-model="filtersNapSelecionado.page"
                  :total-rows="filtersNapSelecionado.total"
                  :per-page="filtersNapSelecionado.perPage"
                  first-number
                  @change="onChanePaginationRepresetanteNaoSelecionado"
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12" md="6">
      <div class="mb-3">
        <h5 class="mb-3 text-success font-weight-bold">
          <feather-icon icon="BriefcaseIcon" size="20" class="mr-1"/>
          Clientes Na Sua Carteira
        </h5>
      </div>
      <b-row class="align-items-center">
        <b-col cols="12">
          <b-row>
            <b-col cols="12" md="3" class="mb-2 mb-md-0">
              <b-form-group
                  label="Código"
                  label-for="basicInput"
              >
                <b-form-input
                    id="basicInput"
                    placeholder="Código"
                    v-model="codigoClienteSelecionado"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="mb-2 mb-md-0">
              <b-form-group
                  label="Nome"
                  label-for="basicInput"
              >
                <b-form-input
                    id="basicInput"
                    placeholder="Nome"
                    v-model="clienteRazaoSocialSelecionado"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2" align-self="center" class="mb-2 mb-md-0">
              <div class="d-flex d-md-block justify-content-center" style="gap: 10px">

                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="btn-icon flex-fill flex-md-grow-0"
                    @click="buscarRepresentanteSelecionado"
                >
                  <feather-icon icon="SearchIcon" class="d-md-none"/>
                  <span class="d-none d-md-inline"><feather-icon icon="SearchIcon"/></span>
                  <span class="d-md-none ml-1">Buscar</span>
                </b-button>
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="danger"
                    class="btn-icon flex-fill flex-md-grow-0"
                    @click="limparBuscarRepresentanteSelecionado"
                >
                  <feather-icon icon="TrashIcon" class="d-md-none"/>
                  <span class="d-none d-md-inline"><feather-icon icon="TrashIcon"/></span>
                  <span class="d-md-none ml-1">Limpar</span>
                </b-button>
              </div>

            </b-col>
          </b-row>
        </b-col>
        <b-col
            cols="12"
            class="mb-3"
        >
          <div class="d-flex flex-column flex-md-row" style="gap: 10px; align-items: stretch;">
            <!-- <b-button
                :disabled="clientesSelecionados.length === 0"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="btn-icon flex-fill flex-md-grow-0"
                @click="removerTodosClienteSelecionados"
            >
              Remover Todos
            </b-button> -->
            <b-button
                v-if="selectedClienteSelecionado.length > 0"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-danger"
                class="btn-icon flex-fill flex-md-grow-0"
                @click="removerSelecionadoClienteSelecionado"
            >
              Remover Selecionados
            </b-button>
            <span
                v-if="selectedClienteSelecionado.length > 0"
                class="font-weight-bolder text-center text-md-left mt-2 mt-md-0"
            >{{selectedClienteSelecionado.length}} selecionados</span>
          </div>
        </b-col>
        <b-col cols="12" class="mb-3">
          <b-table
              responsive="sm"
              :fields="columnsSelecionados"
              :items="clientesSelecionados"
              ref="refTableSelecionados"
              selectable
              select-mode="multi"
              show-empty
              empty-text="Nenhum registro encontrado"
              @row-selected="onRowSelectedRepSelecionado"
              :busy="$store.getters['SISUsuarioCliente/getLoading']"
              class="mobile-table"
          >
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle" variant="primary"></b-spinner>
                    <strong class="ml-2">Carregando...</strong>
                </div>
            </template>
            <template v-slot:head(selected)="data">
              <b-form-checkbox
                  id="cliente-selecionarTodos-selecionados"
                  v-model="data.allSelected"
                  @change="selectAllRepresentanteSelecionado(data)"
              >
              </b-form-checkbox>
              <b-tooltip
                  target="cliente-selecionarTodos-selecionados"
                  title="Marcar todos"
                  variant="secondary"
              >
              </b-tooltip>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <b-form-checkbox
                    v-model="rowSelected"
                    disabled
                >
                </b-form-checkbox>
              </template>
              <template v-else>
                <b-form-checkbox
                    v-model="rowSelected"
                    disabled
                >
                </b-form-checkbox>
              </template>
            </template>
            <template v-slot:cell(acoes)="props">
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="gradient-danger"
                  class="btn-icon"
                  @click="removerRepresentante(props.item)"
              >
                <feather-icon icon="MinusIcon"/>
              </b-button>
            </template>
          </b-table>
        </b-col>
        <b-col
            cols="12"
            v-if="!$store.getters['SISUsuarioCliente/getLoading']"
        >
          <!-- <div v-if="clientesSelecionados.length === 0" class="text-center">
                    <span class="font-weight-bold">
                      Nenhum representante selecionado
                    </span>
          </div> -->
          <div class="d-flex justify-content-between flex-wrap mb-1">
            <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap ">
                      {{ dataMetaSelecionado }}
                    </span>
            </div>
            <div>
              <b-pagination
                  v-model="filtersSelecionados.page"
                  :total-rows="filtersSelecionados.total"
                  :per-page="filtersSelecionados.perPage"
                  first-number
                  @change="onChanePaginationRepresetanteSelecionados"
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  </b-overlay>
</template>

<style scoped>
@media (max-width: 767.98px) {
  .mobile-table {
    font-size: 0.875rem;
  }

  .mobile-table .btn-icon {
    padding: 0.25rem 0.5rem;
    min-height: 44px;
  }

  .b-table-selectable tbody tr:hover {
    background-color: rgba(0, 123, 255, 0.1);
  }

  .btn-icon {
    min-height: 44px;
    touch-action: manipulation;
  }

  .b-pagination {
    justify-content: center;
  }

  .b-pagination .page-link {
    min-height: 44px;
    min-width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
